import "core-js/modules/es.array.push.js";
export default {
  name: "Return",
  data: function data() {
    return {};
  },
  props: ["routeName", "params", "query", "label", "isHistoryBack", "className"],
  methods: {
    backToList: function backToList() {
      if (this.isHistoryBack === true) {
        this.$router.go(-1);
      } else {
        this.$router.push({
          name: this.routeName,
          params: this.params,
          query: this.query
        });
      }
    }
  }
};